import { createFileRoute, Navigate } from "@tanstack/react-router";

// Legacy route: forward to the unified /watch/$id reader so all story
// surfaces hit the same database-backed component.
export const Route = createFileRoute("/_authenticated/app/child/$childId/stories/$storyId")({
  component: RedirectToWatch,
});

function RedirectToWatch() {
  const { storyId } = Route.useParams();
  return <Navigate to="/app/watch/$id" params={{ id: storyId }} replace />;
}
